import Swal from "sweetalert2";
import {color}  from "@/common/data";
export function confirmMsg(options) {
   return new Promise((resolve) =>
      resolve( Swal.fire({
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: color?.primary,
      showLoaderOnConfirm: true,
      allowOutsideClick: ()=> !Swal.isLoading(),
      cancelButtonColor: color?.danger,
      ...options,
    })
    ))
}
export function errorMsg(error, attributes) {
  return new Promise((resolve) =>
    resolve(
      Swal.fire({
        title: "Error!",
        text: error,
        icon: "error",
        showCancelButton: true,
        showConfirmButton: false,
        timer: 3000,
        ...attributes
      })
    )
  );
}
export function successMsg(message, attributes) {
  return new Promise((resolve) =>
    resolve(
      Swal.fire({
        title: "Success!",
        icon: "success",
        text: message,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: color?.primary,
        timer: 2000,
        ...attributes
      })
    )
  );
}
